import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { AdminAuthProvider } from "@/contexts/AdminAuthContext";
import { Toaster } from "sonner";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import OwnerDashboard from "@/pages/OwnerDashboard";
import AuthPage from "@/pages/AuthPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ComoFunciona from "@/pages/ComoFunciona";
import Precos from "@/pages/Precos";
import CentralAjuda from "@/pages/CentralAjuda";
import TrabalheConosco from "@/pages/TrabalheConosco";
import QuemSomos from "@/pages/QuemSomos";
import PoliticaPrivacidade from "@/pages/PoliticaPrivacidade";
import TermosUso from "@/pages/TermosUso";
import DireitosAutorais from "@/pages/DireitosAutorais";
import FAQ from "@/pages/FAQ";
import Demo from "@/pages/Demo";
import AppPage from "@/pages/App";
import PWAInstallBanner from "@/components/PWAInstallBanner";

function App() {
  return (
    <AuthProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <div className="App">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/dashboard" element={<OwnerDashboard />} />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/como-funciona" element={<ComoFunciona />} />
              <Route path="/precos" element={<Precos />} />
              <Route path="/ajuda" element={<CentralAjuda />} />
              <Route path="/trabalhe-conosco" element={<TrabalheConosco />} />
              <Route path="/quem-somos" element={<QuemSomos />} />
              <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
              <Route path="/termos-uso" element={<TermosUso />} />
              <Route path="/direitos-autorais" element={<DireitosAutorais />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/demo" element={<Demo />} />
              <Route path="/app" element={<AppPage />} />
            </Routes>
            <Toaster position="top-right" />
            <PWAInstallBanner />
          </div>
        </BrowserRouter>
      </AdminAuthProvider>
    </AuthProvider>
  );
}

export default App;
